import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import LandingPage from "@/pages/LandingPage";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import GardenKeeper from "@/pages/GardenKeeper";

function App() {
    return (
        <div className="App eden-bg">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<LandingPage />} />
                    <Route path="/payment/success" element={<PaymentSuccess />} />
                    <Route path="/payment/cancel" element={<PaymentCancel />} />
                    <Route path="/keeper" element={<GardenKeeper />} />
                </Routes>
                <Toaster
                    position="bottom-center"
                    toastOptions={{
                        style: {
                            background: "#0f2318",
                            border: "1px solid rgba(212, 175, 55, 0.4)",
                            color: "#f3e5ab",
                            fontFamily: "'Cormorant Garamond', serif",
                            fontSize: "1.05rem",
                        },
                    }}
                />
            </BrowserRouter>
        </div>
    );
}

export default App;
